var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section sectionLoading"},[_c('div',{staticClass:"container-fluid"},[_c('Loading'),_c('p',{staticClass:"text-center mt-2 small text-dark"},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }